import { endsWith } from 'lodash-es';

const IMAGE_EXTENSIONS = [
  '.png',
  '.jpg',
  '.jpeg',
  '.gif',
  '.bmp',
  '.tiff',
  '.webp',
];

const isImageFile = (fileName) => {
  return IMAGE_EXTENSIONS.some((ext) => endsWith(fileName.toLowerCase(), ext));
};

export default isImageFile;
